import React, { useEffect, useState } from "react";
import { Divider, Grid, Button, DropDown, useFormValidation, DropDownWithValidation, Notifier, Typography } from './index';
import { PageHeading } from './mybswh';
import * as Tools from "../../helpers/Tools";
import './test_component.scss';

const ComponentsDemo = (props) => {

    const [selectedMonths, setSelectedMonths] = useState([]);
    const [disabledMonths, setDisabledMonths] = useState([]);
    const [selectedMonths2, setSelectedMonths2] = useState([{ value: '03', label: 'March' }, { value: '09', label: 'September' }]);

    // Validation rules for useFormValidation hook
    const validationRules = {
        selectedMonths: {
            required: {
                value: true,
                message: "Select a month"
            }
        }
    };
    const { handleForm, handleInput, formErrors } = useFormValidation({ validations: validationRules });

    // Disable options based on selected options since only March or April can be selected not both
    useEffect(() => {
        if (selectedMonths?.length > 0) {
            let isMarchSelected = selectedMonths.some(opt => opt.value === '03');
            let isAprilSelected = selectedMonths.some(opt => opt.value === '04');
            if (isMarchSelected) {
                setDisabledMonths([{ value: '04', label: 'April' }]);
            } else if (isAprilSelected) {
                setDisabledMonths([{ value: '03', label: 'March' }]);
            } else {
                setDisabledMonths([]);
            }
        } else {
            setDisabledMonths([]);
        }
    }, [selectedMonths]);

    const handleUserInput = (event, changedItem) => {
        let selOptions = event?.target?.value;

        if (event?.target?.name === 'selectedMonths') {
            // If select all is clicked filter out April since March is default selection
            if (selOptions?.length === 12) {
                let aprilIndex = selOptions.findIndex(opt => { return opt.value === '04' });
                if (aprilIndex !== -1) {
                    selOptions.splice(aprilIndex, 1);
                }
            }
            setSelectedMonths(selOptions);
        } else {
            setSelectedMonths2(selOptions);
        }
        // Triggers validation from useFormValidation hook
        handleInput(event);
    }

    const handleOnBlur = (event) => {
        // Triggers validation from useFormValidation hook
        handleInput(event);
    }

    const handleSubmit = (event) => {
        // Triggers validation from useFormValidation hook
        const formValid = handleForm(event);

        if (formValid.value) {
            alert("submitted");
        }
    }

    const handleSelectAll = (event) => {
        console.log("selected all");
    }

    const [openNotifier, setOpenNotifier] = useState();
    const [openNotifierCustom, setOpenNotifierCustom] = useState();

    return (
        <Grid className="body-content bsw-test-components">
            <div className="row">
                <div className="col-12 col-lg-8">
                    <PageHeading heading="Components" />
                    <Notifier
                        accordion={{
                            open: openNotifier,
                            toggle: () => setOpenNotifier(!openNotifier)
                        }}
                        heading="What’s the difference between 2D and 3D mammograms?"
                        icon="alert"
                    >
                        <div className="mammogram-notifier">
                            <p>A two-dimensional (2D) mammogram is a conventional mammogram while a three-dimensional (3D) mammogram is an approach to provide a clearer, top-quality image of the breast tissue. For you as the patient, the experience is the same for both versions and insurance usually covers both annually.</p>
                            <p>A 3D mammogram gives your doctor a better chance of detecting breast problems earlier and reduces the risk of false positives. When possible, we recommend having a 3D mammogram. If a 3D mammogram isn't available in your area, a 2D mammogram is still a clinically effective way to detect breast problems and far better than no mammogram at all.</p>
                        </div>
                    </Notifier>
                    <br />
                    <Notifier
                        accordion={{
                            open: openNotifierCustom,
                            toggle: () => setOpenNotifierCustom(!openNotifierCustom)
                        }}
                        heading={<Typography type="body-01" color="$color-primary-a2">What’s the difference between 2D and 3D mammograms?</Typography>}
                        icon="alert"
                    >
                        <Typography type="body-01" color="$color-primary-a2">
                            <p>A two-dimensional (2D) mammogram is a conventional mammogram while a three-dimensional (3D) mammogram is an approach to provide a clearer, top-quality image of the breast tissue. For you as the patient, the experience is the same for both versions and insurance usually covers both annually.</p>
                            <p>A 3D mammogram gives your doctor a better chance of detecting breast problems earlier and reduces the risk of false positives. When possible, we recommend having a 3D mammogram. If a 3D mammogram isn't available in your area, a 2D mammogram is still a clinically effective way to detect breast problems and far better than no mammogram at all.</p>
                        </Typography>
                    </Notifier>
                    <Divider mTop="xlarge" />
                    <DropDown
                        label="Months"
                        options={Tools.getMonths()}
                        id="selectedMonths"
                        name="selectedMonths"
                        onBlur={(e) => { handleOnBlur(e) }}
                        onChange={(e, changedItem) => { handleUserInput(e, changedItem); }}
                        onSelectAllClick={(e) => { handleSelectAll(e); }}
                        required
                        multiselect
                        multiselectCount={Tools.getMonths().length - 1}
                        showSelectAll
                        selectedOptions={selectedMonths}
                        disabledOptions={disabledMonths}
                        colorStyle={formErrors['selectedMonths']?.value ? 'error' : 'neutral'}
                        hintMsg={formErrors['selectedMonths']?.message || 'Only 11 months can be selected'}
                    />
                    <Button onClick={handleSubmit}>Submit</Button>
                    <Divider mTop="xlarge" />
                    <DropDownWithValidation
                        label="Months"
                        options={Tools.getMonths()}
                        id="selectedMonths2"
                        name="selectedMonths2"
                        onBlur={(e) => { handleOnBlur(e) }}
                        onChange={(e, changedItem) => { handleUserInput(e); }}
                        required
                        multiselect
                        selectedOptions={selectedMonths2}
                        errorMsg="Please select month"
                    />
                </div>
            </div>
        </Grid>
    );

}

export default ComponentsDemo;
